<script>
	export let lang = "en";
	import { createEventDispatcher } from "svelte";

	const dispatch = createEventDispatcher();
</script>

<!-- <svelte:head>
	<script
		src="https://kit.fontawesome.com/51ec7a37fa.js"
		crossorigin="anonymous"
	></script>
</svelte:head> -->

<svelte:body class="vg-autorow-body" />

<footer class="px-10 py-24 text-white bg-black xl:px-40 md:px-20">
	<div class="grid justify-between gap-10 text-base md:flex sm:grid-flow-col">
		<div>
			{#if lang === "bg"}
				<h3>
					Градски преживявания<br />
					от ново поколение.
				</h3>
			{:else}
				<h3>
					New generation of<br />
					urban adventures.
				</h3>
			{/if}
		</div>
		<div class="pt-4 text-sm opacity-70 hover:opacity-100">
			<button
				class={lang === "bg" ? "hidden" : "text-left"}
				on:click={() =>
					dispatch("setLang", {
						lang: "bg",
						prefset: true,
					})}
				><i class="fa-solid fa-globe" /> Премини на български език (Bulgarian)</button
			>
			<button
				class={lang === "en" ? "hidden" : "text-left"}
				on:click={() =>
					dispatch("setLang", {
						lang: "en",
						prefset: true,
					})}
				><i class="fa-solid fa-globe" /> Change to English (Английски)</button
			>
		</div>
		<div>
			{#if lang === "bg"}
				<h3
					class="mb-4 font-extrabold tracking-wider uppercase text-subheading text-yellow"
				>
					Последвай ни
				</h3>
			{:else}
				<h3
					class="mb-4 font-extrabold tracking-wider uppercase text-subheading text-yellow"
				>
					Follow us
				</h3>
			{/if}
			<ul class="grid justify-between grid-cols-3 gap-x-4 place-items-start">
				<li>
					<a
						href="https://instagram.com/vutreshenglas"
						target="_blank"
						class="opacity-50 hover:opacity-80 text-link"
						><i class="fa-brands fa-instagram" /></a
					>
				</li>
				<li>
					<a
						href="https://m.me/vutreshenglas"
						target="_blank"
						class="opacity-50 hover:opacity-80 text-link"
						><i class="fa-brands fa-facebook-messenger" /></a
					>
				</li>
				<li>
					<a
						href="https://facebook.com/vutreshenglas"
						target="_blank"
						class="opacity-50 hover:opacity-80 text-link"
						><i class="fa-brands fa-facebook" /></a
					>
				</li>
			</ul>
		</div>
	</div>
</footer>

<style>
</style>
